module.exports = __webpack_public_path__ + "static/icons/icon-gear-85b4a0d729881f17ec0888d1f158dade.svg";